/**
* OverlayImageContent.js
* 
* Created on 27-02-18
*
* @author Olivier van der Pool for &ranj
**/

import Content from "../Content";
import ContentFactory from "../ContentFactory";
import ContentTypes from "../ContentTypes";
import ENGLanguagePackContentType from "../ENGLanguagePackContentType";

export default class OverlayImageContent extends Content {
    constructor(languagePack, contentID, label) {
        super(OverlayImageContent.NAME, ContentTypes.TYPE_OVERLAY_IMAGE, label, languagePack, contentID);
    }

    remove() {
        this.removeLanguagePackContent(OverlayImageContent.IMAGE_LABEL, ENGLanguagePackContentType.IMAGE);
        this.removeLanguagePackText(OverlayImageContent.NAME_LABEL);
        this.removeLanguagePackText(OverlayImageContent.ACTION_LABEL);
        this.removeLanguagePackText(OverlayImageContent.DIRECTION_LABEL);
        super.remove();
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_OVERLAY_IMAGE, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setImage(this.getImage());
        clone.setAction(this.getAction());
        clone.setDirection(this.getDirection());
        clone.setTime(this.getTime());
        clone.setWait(this.getWait());
        clone.setBackgroundOverlay(this.getBackgroundOverlay());
        clone.setX(this.getX());
        clone.setY(this.getY());
        return clone;
    }

    getName() {
        return this.getLanguagePackText(OverlayImageContent.NAME_LABEL);
    }

    setName(value) {
        this.setLanguagePackText(OverlayImageContent.NAME_LABEL, value);
    }

    getImage() {
        return this.getLanguagePackContent(OverlayImageContent.IMAGE_LABEL, ENGLanguagePackContentType.IMAGE);
    }

    setImage(value) {
        this.setLanguagePackContent(OverlayImageContent.IMAGE_LABEL, ENGLanguagePackContentType.IMAGE, value);
    }

    getAction() {
        return this.getLanguagePackText(OverlayImageContent.ACTION_LABEL);
    }

    setAction(value) {
        this.setLanguagePackText(OverlayImageContent.ACTION_LABEL, value);
    }

    getDirection() {
        return this.getLanguagePackText(OverlayImageContent.DIRECTION_LABEL);
    }

    setDirection(value) {
        this.setLanguagePackText(OverlayImageContent.DIRECTION_LABEL, value);
    }

    getTime() {
        return this._time;
    }

    setTime(value) {
        this._time = value;
    }

    getWait() {
        return this._wait;
    }

    setWait(value) {
        this._wait = value;
    }

    getBackgroundOverlay() {
        return this._backgroundOverlay;
    }

    setBackgroundOverlay(value) {
        this._backgroundOverlay = value;
    }

    getX() {
        return this._x;
    }

    setX(value) {
        this._x = value;
    }

    getY() {
        return this._y;
    }

    setY(value) {
        this._y = value;
    }

    convertToObject() {
        return this.getObject(["time", "wait", "backgroundOverlay", "x", "y"]);
    }
}

OverlayImageContent.NAME = "Overlay Image";
OverlayImageContent.TYPE = "engOverlayImage";

OverlayImageContent.NAME_LABEL = "name";
OverlayImageContent.IMAGE_LABEL = "image";
OverlayImageContent.ACTION_LABEL = "action";
OverlayImageContent.DIRECTION_LABEL = "direction";


